import React from 'react'

import { Star1 } from 'iconsax-react'

import styles from './styles.module.css'
import { _getDateText } from 'utils/_helpers'
import useColors from 'utils/Colors'

const CommentCard = ({
  reply,
  created_date,
  star,
  comment_text,
  ticket_reply,
  user,
  ...props
}) => {
  const Colors = useColors()

  return (
    <div className={styles.container}>
      <div
        className="d-flex justify-content-between align-items-start"
        style={{ marginBottom: 8 }}
      >
        <div className="d-flex flex-column align-items-start">
          <h6
            className={styles.name}
          >{`${user.first_name} ${user.last_name}`}</h6>
          <span className={styles.date}>
            {_getDateText(created_date, true)}
          </span>
        </div>
        <div className="d-flex align-items-center">
          <span className={styles.rate}>{star}</span>
          <Star1
            variant="Bold"
            style={{ marginRight: 2 }}
            color={
              star >= 4
                ? '#029C53'
                : star >= 2
                ? Colors.Warning[10]
                : Colors.Danger[4]
            }
            size={16}
          />
        </div>
      </div>
      <p className={styles.body}>{comment_text}</p>
      {ticket_reply && (
        <div className={styles.reply}>
          <h6>پشتیبانی پگاه</h6>
          <p>{ticket_reply.comment_text}</p>
        </div>
      )}
    </div>
  )
}

export default CommentCard
